import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Sentry } from "../lib/sentry";

export const Route = createFileRoute("/sentry-test")({
  component: SentryTestPage,
});

function SentryTestPage() {
  const [eventId, setEventId] = useState<string | null>(null);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-bg px-4">
      <h1 className="text-3xl font-bold text-ink">Sentry Test</h1>
      <button
        onClick={() => {
          const id = Sentry.captureException(new Error("DeckScore Sentry test error"));
          setEventId(id);
        }}
        className="inline-flex items-center justify-center rounded-xl bg-accent px-5 py-3 text-sm font-bold text-accent-ink transition hover:bg-accent-press"
      >
        Throw test error
      </button>
      {eventId && (
        <p className="text-sm text-muted-ink">Test error sent to Sentry (id: {eventId})</p>
      )}
    </div>
  );
}
